module.exports = __webpack_public_path__ + "img/trem.f860fe29.png";